// app/frontend/components/ui/Stepper/StepShell.tsx
import { Box, Stack } from "@mantine/core";
import { L2KH2, L2KText } from "../Typography";
import { L2KCard } from "../Cards";
import type { StepShellProps } from "./types";

/**
 * StepShell - Layout wrapper for each step providing consistent styling
 * Features glassmorphism card aesthetic with fade-in animation
 */
export function StepShell({
  title,
  subtitle,
  children,
  animate = true,
  maxWidth = 600,
  centered = true,
}: StepShellProps) {
  return (
    <Box
      style={{
        width: "100%",
        maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth,
        margin: centered ? "0 auto" : undefined,
        animation: animate ? "fadeIn 0.3s ease-out" : undefined,
      }}
    >
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <L2KCard variant="elevated" glow>
        <Stack gap="lg">
          <Stack gap="xs" ta={centered ? "center" : undefined}>
            <L2KH2>{title}</L2KH2>
            {subtitle && <L2KText variant="secondary">{subtitle}</L2KText>}
          </Stack>
          {children}
        </Stack>
      </L2KCard>
    </Box>
  );
}

export default StepShell;
